/**************************************************
 * Nombre:       Ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Divider, Grid, Typography} from "@mui/material";
import {Feed, Login} from "@mui/icons-material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Ingreso from "../Formularios/Formulario_Ingreso";
import {funIngresarCorreoPass} from "../../Servicios/Auth/funIngresarCorreoPass";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {funRecuperarContrasena} from "../../Servicios/Auth/funRecuperarContrasena";

const Ingreso = ({clickRegistro}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Avisos, Cargador, iniciarCarga, terminar} = useCargador({logoRedondo: logo})

    const ingreso = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Ingresando')
        let dox = await funIngresarCorreoPass(entidad.correo, entidad.pass)
        if (dox.res) {
            terminar({aviso: 'Ingreso Exitoso, Redirigiendo'})
        } else {
            terminar({aviso: dox.data, variante: 'error'})
        }


    }

    const recuperar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Enviando datos')
        let dox = await funRecuperarContrasena(entidad.correo)
        if (dox.res) {
            terminar({aviso: 'Se ha enviado las instrucciones al correo ' + entidad.correo})
        }
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
            sx={{py: 8,}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 32, fontWeight: 800, px: 1}}>Hola!</Typography>
            </Grid>

            <Grid container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: -2}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, px: 1, lineHeight: 1.1}}>
                    Si ya eres usuario de Esperanza Hispana accede con tu correo y contraseña
                </Typography>
            </Grid>

            <Grid container size={12} sx={{justifyContent: 'center', mt: 2}}>
                <Formulario_Ingreso props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    onClick={() => ingreso()}
                    startIcon={<Login/>}>Ingresar</Button>
            </Grid>


            <Grid container size={8}
                  sx={{justifyContent: 'flex-start', marginTop: 2}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, px: 1, lineHeight: 1.1, color: '#00000080'}}>Haz
                    olvidado tu
                    contraseña?</Typography>
            </Grid>


            <Grid container size={4} sx={{justifyContent: 'flex-end', px: 1, mt: 2}}>
                <Button
                    onClick={() => recuperar()}
                    variant={'text'} sx={{px: 4}}>Recuperarla</Button>
            </Grid>


            <Grid container size={12} sx={{marginTop: 2}}>
                <Divider sx={{width: '100%'}}/>
            </Grid>


            <Grid container size={6} sx={{justifyContent: 'flex-start', px: 1}}>
                <Typography sx={{lineHeight: 1.1, fontWeight: 600}}>Aun no eres usuario? Registrate</Typography>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-end', px: 1}}>
                <Button
                    onClick={() => clickRegistro()}
                    startIcon={<Feed/>}>Registrarme</Button>
            </Grid>

        </Grid>
    )

}
export default Ingreso